import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issue: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.issue-table.issue',
		defaultMessage: 'Issue',
		description: 'Title for a table column showing issue details.',
	},
	issueIssueTermRefresh: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.issue-table.issue-issue-term-refresh',
		defaultMessage: 'Work item',
		description: 'Title for a table column showing issue details.',
	},
	assignee: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.issue-table.assignee',
		defaultMessage: 'Assignee',
		description: 'Title for a table column showing issue assignee names.',
	},
	status: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.issue-table.status',
		defaultMessage: 'Status',
		description: 'Title for a table column showing issue statuses (e.g. "Done", "In-progress").',
	},
});
